import {
  ZENDESK_FIRST_NAME_INPUT_NAME,
  ZENDESK_LAST_NAME_INPUT_NAME,
  ZENDESK_EMAIL_INPUT_NAME,
  ZENDESK_PHONE_NUM_INPUT_NAME,
  ZENDESK_COMPANY_SIZE_INPUT_NAME,
  ZENDESK_TICKET_SUBJECT_NAME,
  ZENDESK_TOPIC_INPUT_NAME,
  ZENDESK_TICKET_DESCRIPTION_NAME,
  ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME,
  getTopicZendeskValue
} from "client/services/zendesk-service/zendesk-inputs";
import { getCookie } from "/services/cookies-service";
import { BIG_BRAIN_VISITOR_ID, MONDAY_PLATFORM_USER_ID, MONDAY_PLATFORM_ACCOUNT_ID } from "/constants/cookies";

const WEBSITE_CREATE_ZENDESK_ENDPOINT = "/dynamic/zendesk/create-ticket";
const CONTACT_SUPPORT_TAG = "contact_support"; //Tag used in zendesk by CS to indicate that the ticket came from the website
const FORM_SUBJECT_CUSTOM_FIELD_ID = "360019382000";
const VISITOR_ID_CUSTOM_FIELD_ID = "360012757600";
const USER_ID_CUSTOM_FIELD_ID = "26277389";
const ACCOUNT_ID_CUSTOM_FIELD_ID = "45339389";
const PHONE_CUSTOM_FIELD_ID = "28477529";
const COMPANY_SIZE_FIELD_ID = "360015085720";
const CONTACT_CONSENT_CUSTOM_FIELD_ID = "360018385139";

const COOKIE_VALUE_TO_CUSTOM_FIELD = [
  { cookie: BIG_BRAIN_VISITOR_ID, customFieldId: VISITOR_ID_CUSTOM_FIELD_ID },
  { cookie: MONDAY_PLATFORM_USER_ID, customFieldId: USER_ID_CUSTOM_FIELD_ID },
  { cookie: MONDAY_PLATFORM_ACCOUNT_ID, customFieldId: ACCOUNT_ID_CUSTOM_FIELD_ID }
];

const fillCustomFieldsFromCookies = (customFields) => {
  COOKIE_VALUE_TO_CUSTOM_FIELD.forEach((item) => {
    const customFieldInfo = getCustomFieldValueFromCookie(item.cookie, item.customFieldId);
    if (customFieldInfo) customFields.push(customFieldInfo);
  });
};

const getTicketTags = () => {
  return [CONTACT_SUPPORT_TAG];
};

const getTopicCustomField = (topicField) => {
  const value = getTopicZendeskValue(topicField);
  if (!value) return null;

  return { id: FORM_SUBJECT_CUSTOM_FIELD_ID, value };
};

const getCustomFieldValueFromCookie = (cookieName, customFieldId) => {
  const value = getCookie(cookieName);
  if (!value) return null;

  return { id: customFieldId, value };
};

const getAllCustomFields = (formData) => {
  const customFields = [];
  fillCustomFieldsFromCookies(customFields);

  const topicCustomField = getTopicCustomField(formData[ZENDESK_TOPIC_INPUT_NAME]);
  if (topicCustomField) customFields.push(topicCustomField);

  if (formData[ZENDESK_PHONE_NUM_INPUT_NAME])
    customFields.push({ id: PHONE_CUSTOM_FIELD_ID, value: formData[ZENDESK_PHONE_NUM_INPUT_NAME] });
  if (formData[ZENDESK_COMPANY_SIZE_INPUT_NAME])
    customFields.push({ id: COMPANY_SIZE_FIELD_ID, value: formData[ZENDESK_COMPANY_SIZE_INPUT_NAME] });
  if (formData[ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME])
    customFields.push({
      id: CONTACT_CONSENT_CUSTOM_FIELD_ID,
      value: formData[ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME]
    });

  return customFields;
};

const generateZendeskTicketBody = (formData) => {
  const email = formData[ZENDESK_EMAIL_INPUT_NAME];
  const name = `${formData[ZENDESK_FIRST_NAME_INPUT_NAME]} ${formData[ZENDESK_LAST_NAME_INPUT_NAME]}`;
  const subject = formData[ZENDESK_TICKET_SUBJECT_NAME];
  const body = `Phone: ${formData[ZENDESK_PHONE_NUM_INPUT_NAME]} \nCompany Size: ${formData[ZENDESK_COMPANY_SIZE_INPUT_NAME]}\nMessage: ${formData[ZENDESK_TICKET_DESCRIPTION_NAME]}`;
  const tags = getTicketTags();
  const custom_fields = getAllCustomFields(formData);

  return { subject, comment: { body }, tags, custom_fields, requester: { email, name } };
};

export const createZendeskTicket = async (formData) => {
  const ticket = generateZendeskTicketBody(formData);

  const request = await fetch(WEBSITE_CREATE_ZENDESK_ENDPOINT, {
    method: "POST",
    body: JSON.stringify({
      ticket
    }),
    headers: {
      "content-type": "application/json"
    }
  });

  try {
    const response = await request.json();
    return { success: response.success, message: response.message };
  } catch (e) {
    return { success: false };
  }
};
